import {memo} from 'react'

/* @autogenerated optimization completed by @naverpay/optimize-svg-components */
import {SvgUniqueID} from '@naverpay/svg-manager'

import type {SVGStyleProps} from '@naverpay/svg-manager'

const IconGraphHigh = memo(
    ({width = '100%', height = '100%', viewBox = '0 0 30 30', id, style = {}}: SVGStyleProps) => (
        <SvgUniqueID id={id}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                viewBox={viewBox}
                style={style}
                fill="none"
            >
                <path
                    d="M16.7656 2C16.7656 0.89543 17.6611 0 18.7656 0H24.5311C25.6357 0 26.5311 0.895431 26.5311 2V28C26.5311 29.1046 25.6357 30 24.5311 30H18.7656C17.6611 30 16.7656 29.1046 16.7656 28V2Z"
                    fill="#F73631"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.5311 1H18.7656C18.2133 1 17.7656 1.44772 17.7656 2V28C17.7656 28.5523 18.2133 29 18.7656 29H24.5311C25.0834 29 25.5311 28.5523 25.5311 28V2C25.5311 1.44772 25.0834 1 24.5311 1ZM18.7656 0C17.6611 0 16.7656 0.89543 16.7656 2V28C16.7656 29.1046 17.6611 30 18.7656 30H24.5311C25.6357 30 26.5311 29.1046 26.5311 28V2C26.5311 0.895431 25.6357 0 24.5311 0H18.7656Z"
                    fill="#F73631"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.5311 1H18.7656C18.2133 1 17.7656 1.44772 17.7656 2V28C17.7656 28.5523 18.2133 29 18.7656 29H24.5311C25.0834 29 25.5311 28.5523 25.5311 28V2C25.5311 1.44772 25.0834 1 24.5311 1ZM18.7656 0C17.6611 0 16.7656 0.89543 16.7656 2V28C16.7656 29.1046 17.6611 30 18.7656 30H24.5311C25.6357 30 26.5311 29.1046 26.5311 28V2C26.5311 0.895431 25.6357 0 24.5311 0H18.7656Z"
                    fill="black"
                    fillOpacity="0.05"
                />
                <path
                    d="M4 17C4 15.8954 4.89543 15 6 15H11.7655C12.8701 15 13.7655 15.8954 13.7655 17V28C13.7655 29.1046 12.8701 30 11.7655 30H6C4.89543 30 4 29.1046 4 28V17Z"
                    fill="#DCDEE0"
                />
                <path
                    d="M4.5 17C4.5 16.1716 5.17157 15.5 6 15.5H11.7655C12.5939 15.5 13.2655 16.1716 13.2655 17V28C13.2655 28.8284 12.5939 29.5 11.7655 29.5H6C5.17157 29.5 4.5 28.8284 4.5 28V17Z"
                    stroke="black"
                    strokeOpacity="0.05"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7655 16H6C5.44772 16 5 16.4477 5 17V28C5 28.5523 5.44772 29 6 29H11.7655C12.3178 29 12.7655 28.5523 12.7655 28V17C12.7655 16.4477 12.3178 16 11.7655 16ZM6 15C4.89543 15 4 15.8954 4 17V28C4 29.1046 4.89543 30 6 30H11.7655C12.8701 30 13.7655 29.1046 13.7655 28V17C13.7655 15.8954 12.8701 15 11.7655 15H6Z"
                    fill="#DCDEE0"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.7655 16H6C5.44772 16 5 16.4477 5 17V28C5 28.5523 5.44772 29 6 29H11.7655C12.3178 29 12.7655 28.5523 12.7655 28V17C12.7655 16.4477 12.3178 16 11.7655 16ZM6 15C4.89543 15 4 15.8954 4 17V28C4 29.1046 4.89543 30 6 30H11.7655C12.8701 30 13.7655 29.1046 13.7655 28V17C13.7655 15.8954 12.8701 15 11.7655 15H6Z"
                    fill="black"
                    fillOpacity="0.05"
                />
            </svg>
        </SvgUniqueID>
    ),
)

export default IconGraphHigh
